<template>
  <div class="bh-benefits pt-48 md:pt-80">
    <section>
      <router-view />
    </section>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BhBenefits',
};
</script>
